module.exports = __webpack_public_path__ + "assets/img/index-partner32.11e16d5f.jpg";